/*
  MDL Cart Suite v2 (Jul 6) — Musk de Lumière
  Luxury-minimal pass: single shipping line, total row only when it adds information,
  voucher form stays closed once a chip is active, success message fades,
  Discovery banner text condensed from config (mdl-header.liquid untouched).
  Wraps the drawer's own globals (mdlhCartOpen / mdlhCartRender).
  Degrades gracefully: if anything is missing, the native drawer keeps working.
*/
(function () {
  'use strict';
  if (window.__MDL_CART_SUITE__) return;
  window.__MDL_CART_SUITE__ = true;

  var STATE_KEY = 'mdl_est_state';
  var STATES = {
    AL:'Alabama',AZ:'Arizona',AR:'Arkansas',CA:'California',CO:'Colorado',CT:'Connecticut',
    DE:'Delaware',DC:'District of Columbia',FL:'Florida',GA:'Georgia',ID:'Idaho',IL:'Illinois',
    IN:'Indiana',IA:'Iowa',KS:'Kansas',KY:'Kentucky',LA:'Louisiana',ME:'Maine',MD:'Maryland',MA:'Massachusetts',
    MI:'Michigan',MN:'Minnesota',MS:'Mississippi',MO:'Missouri',MT:'Montana',NE:'Nebraska',NV:'Nevada',
    NH:'New Hampshire',NJ:'New Jersey',NM:'New Mexico',NY:'New York',NC:'North Carolina',ND:'North Dakota',
    OH:'Ohio',OK:'Oklahoma',OR:'Oregon',PA:'Pennsylvania',RI:'Rhode Island',SC:'South Carolina',SD:'South Dakota',
    TN:'Tennessee',TX:'Texas',UT:'Utah',VT:'Vermont',VA:'Virginia',WA:'Washington',WV:'West Virginia',
    WI:'Wisconsin',WY:'Wyoming'
  };

  var cfg = {}, rates = {}, copy = {}, zones = {};
  var cart = null;
  var lastTrack = {};
  var vmsgTimer = null;

  function $(id) { return document.getElementById(id); }

  function readJSON(id) {
    var el = $(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function money(cents) {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: (cfg.currency || 'USD') }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  function track(name, payload) {
    if (lastTrack[name] && Date.now() - lastTrack[name] < 800) return;
    lastTrack[name] = Date.now();
    var data = payload || {};
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data)); } catch (e) {}
  }

  var ZERO_TAX = ['AK', 'DE', 'MT', 'NH', 'OR'];

  function currentRate(code) {
    var entry = rates[code];
    if (!entry) return ZERO_TAX.indexOf(code) !== -1 ? 0 : null;
    var r = Number(entry.r);
    if (entry.fr != null && entry.fd) {
      var eff = new Date(entry.fd + 'T00:00:00');
      if (!isNaN(eff) && new Date() >= eff) r = Number(entry.fr);
    }
    return isNaN(r) ? null : r;
  }

  function deliveryText(code) {
    if (!code) return copy.deliveryDefault || 'Typically 3–5 business days';
    if (code === 'INTL') return copy.deliveryIntl || 'varies by destination';
    for (var label in zones) {
      if (zones[label].indexOf(code) !== -1) return label;
    }
    return copy.deliveryDefault || 'Typically 3–5 business days';
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; return c; });
  }

  function applicableCodes(c) {
    return ((c && c.discount_codes) || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
  }

  function postCartUpdate(body) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('cart_update_failed');
      return r.json();
    });
  }

  /* ---------- render ---------- */

  function render() {
    if (!cart || !$('mdlcs')) return;

    var sel = $('mdlcsState');
    var state = sel ? sel.value : '';
    var netCents = cart.total_price;
    // Offer = code value only; line-level savings (e.g. the complimentary sample)
    // already tell their story on their own line.
    var lineDiscounts = 0;
    (cart.items || []).forEach(function (i) { lineDiscounts += i.line_level_total_discount || 0; });
    var discountCents = Math.max((cart.total_discount || 0) - lineDiscounts, 0);

    var offerRow = $('mdlcsOfferRow'), offerVal = $('mdlcsOfferVal');
    if (offerRow && offerVal) {
      if (discountCents > 0) {
        offerVal.textContent = '−' + money(discountCents);
        offerRow.hidden = false;
      } else offerRow.hidden = true;
    }

    var shipVal = $('mdlcsShipVal');
    if (shipVal) {
      shipVal.textContent = (state === 'INTL')
        ? (copy.intlShipping || 'Calculated at checkout')
        : (copy.complimentary || 'Complimentary') + ' · ' + deliveryText(state);
    }

    var taxCents = null;
    if (state && state !== 'INTL') {
      var rate = currentRate(state);
      if (rate == null) showTax(copy.taxCheckout || 'Calculated at checkout', state);
      else { taxCents = Math.round(netCents * rate / 100); showTax(money(taxCents), state); }
    } else if (state === 'INTL') {
      showTax(copy.taxCheckout || 'Calculated at checkout', null);
    } else {
      if ($('mdlcsTaxLabel')) $('mdlcsTaxLabel').textContent = copy.tax || 'Estimated tax';
      if ($('mdlcsTaxVal')) { $('mdlcsTaxVal').hidden = true; $('mdlcsTaxVal').textContent = ''; }
      if ($('mdlcsStateWrap')) $('mdlcsStateWrap').hidden = false;
    }

    var totalRow = $('mdlcsTotalRow');
    var meaningful = discountCents > 0 || taxCents != null || state === 'INTL';
    if (totalRow) totalRow.hidden = !meaningful;
    if ($('mdlcsTotalVal')) $('mdlcsTotalVal').textContent = money(netCents + (taxCents || 0));

    renderChips();
  }

  function showTax(text, stateCode) {
    var label = $('mdlcsTaxLabel'), val = $('mdlcsTaxVal'), wrap = $('mdlcsStateWrap');
    if (label) label.textContent = (copy.tax || 'Estimated tax') + (stateCode ? ' (' + stateCode + ')' : '');
    if (wrap) wrap.hidden = true;
    if (val) {
      val.hidden = false;
      val.innerHTML = '';
      val.appendChild(document.createTextNode(text));
      var change = document.createElement('button');
      change.type = 'button';
      change.className = 'mdlcs__change';
      change.textContent = 'Change';
      change.addEventListener('click', function () {
        val.hidden = true;
        if (wrap) { wrap.hidden = false; var s = $('mdlcsState'); if (s) s.focus(); }
      });
      val.appendChild(change);
    }
  }

  /* ---------- voucher ---------- */

  function vmsg(text, ok) {
    var el = $('mdlcsVMsg');
    if (!el) return;
    clearTimeout(vmsgTimer);
    el.style.opacity = '1';
    if (!text) { el.hidden = true; return; }
    el.hidden = false;
    el.textContent = text;
    el.className = 'mdlcs__vmsg ' + (ok ? 'is-ok' : 'is-error');
    if (ok) {
      vmsgTimer = setTimeout(function () {
        el.style.opacity = '0';
        setTimeout(function () { el.hidden = true; el.style.opacity = '1'; }, 450);
      }, 2400);
    }
  }

  function nativeRefresh() {
    try { if (typeof window.mdlhCartRender === 'function') window.mdlhCartRender(); } catch (e) {}
  }

  function submitVoucher() {
    var input = $('mdlcsVInput'), apply = $('mdlcsVApply');
    if (!input) return;
    var code = (input.value || '').trim();
    if (!code) return;
    var existing = applicableCodes(cart);
    if (existing.some(function (c) { return c.toUpperCase() === code.toUpperCase(); })) {
      vmsg(copy.applied || 'Code applied.', true);
      return;
    }
    if (apply) { apply.disabled = true; apply.textContent = copy.applying || 'Applying…'; }
    vmsg('');

    postCartUpdate({ discount: existing.concat([code]).join(',') })
      .then(function (c) {
        var entry = (c.discount_codes || []).filter(function (d) { return d.code.toUpperCase() === code.toUpperCase(); })[0];
        if (entry && entry.applicable) {
          cart = c;
          input.value = '';
          var form = $('mdlcsVForm'), toggle = $('mdlcsVToggle');
          if (form) form.hidden = true;
          if (toggle) toggle.setAttribute('aria-expanded', 'false');
          vmsg(copy.applied || 'Code applied.', true);
          track('mdl_voucher_applied', { code: code });
          nativeRefresh();
          render();
        } else {
          track('mdl_voucher_failed', { code: code });
          vmsg(existing.length ? (copy.notCombinable || 'This code can’t be combined with the current offer.') : (copy.invalid || 'This code isn’t valid.'), false);
          return postCartUpdate({ discount: existing.join(',') }).then(function (c2) { cart = c2; render(); });
        }
      })
      .catch(function () { vmsg(copy.networkError || 'Something went wrong. Please try again.', false); })
      .then(function () {
        if (apply) { apply.disabled = false; apply.textContent = 'Apply'; }
      });
  }

  function removeVoucher(code) {
    var remaining = applicableCodes(cart).filter(function (c) { return c.toUpperCase() !== code.toUpperCase(); });
    postCartUpdate({ discount: remaining.join(',') })
      .then(function (c) {
        cart = c;
        vmsg('');
        track('mdl_voucher_removed', { code: code });
        nativeRefresh();
        render();
      })
      .catch(function () { vmsg(copy.networkError || 'Something went wrong. Please try again.', false); });
  }

  function renderChips() {
    var wrap = $('mdlcsChips');
    if (!wrap) return;
    var codes = applicableCodes(cart);
    wrap.innerHTML = '';
    if (!codes.length) { wrap.hidden = true; return; }
    wrap.hidden = false;
    codes.forEach(function (code) {
      var chip = document.createElement('span');
      chip.className = 'mdlcs__chip';
      var label = document.createElement('span');
      label.textContent = code;
      var x = document.createElement('button');
      x.type = 'button';
      x.setAttribute('aria-label', ((window.mdlI18n && window.mdlI18n.removeCode) || 'Remove code') + ' ' + code);
      x.textContent = '×';
      x.addEventListener('click', function () { removeVoucher(code); });
      chip.appendChild(label);
      chip.appendChild(x);
      wrap.appendChild(chip);
    });
  }

  /* ---------- bind ---------- */

  function bind() {
    if (!$('mdlcs')) return false;

    cfg = readJSON('mdl-cart-suite-config') || {};
    rates = readJSON('mdl-tax-rates') || {};
    copy = cfg.copy || {};
    zones = cfg.deliveryZones || {};

    if (copy.voucherBanner) {
      var bannerText = document.querySelector('#mdlhCdVoucher .mdlh__cd-voucher-t');
      if (bannerText) bannerText.innerHTML = copy.voucherBanner;
    }

    var sel = $('mdlcsState');
    if (sel && sel.options.length <= 2) {
      Object.keys(STATES).sort(function (a, b) { return STATES[a] < STATES[b] ? -1 : 1; }).forEach(function (code) {
        var o = document.createElement('option');
        o.value = code; o.textContent = STATES[code];
        sel.appendChild(o);
      });
      var saved = null;
      try { saved = localStorage.getItem(STATE_KEY); } catch (e) {}
      if (saved && STATES[saved]) sel.value = saved;
      sel.addEventListener('change', function () {
        try { localStorage.setItem(STATE_KEY, sel.value); } catch (e) {}
        if (sel.value && sel.value !== 'INTL') track('mdl_tax_estimate_set', { state: sel.value });
        render();
      });
    }

    var toggle = $('mdlcsVToggle'), form = $('mdlcsVForm'), input = $('mdlcsVInput'), apply = $('mdlcsVApply');
    if (toggle && form) {
      toggle.addEventListener('click', function () {
        var open = form.hidden;
        form.hidden = !open;
        toggle.setAttribute('aria-expanded', String(open));
        if (open && input) input.focus();
      });
    }
    if (input) input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); submitVoucher(); } });
    if (apply) apply.addEventListener('click', submitVoucher);

    document.querySelectorAll('.mdlh__cd-checkout').forEach(function (a) {
      a.addEventListener('click', function () {
        track('mdl_checkout_click', {
          cart_total: cart ? cart.total_price : null,
          est_state: sel ? sel.value : null,
          has_voucher: cart ? applicableCodes(cart).length > 0 : false
        });
      });
    });

    return true;
  }

  function refresh() {
    fetchCart().then(render).catch(function () {});
  }

  function wrapDrawerGlobals() {
    var origOpen = window.mdlhCartOpen;
    if (typeof origOpen === 'function' && !origOpen.__mdlWrapped) {
      var wrappedOpen = function (e) {
        var r;
        try { r = origOpen(e); } catch (err) { r = false; }
        refresh();
        track('mdl_drawer_open', {});
        return r;
      };
      wrappedOpen.__mdlWrapped = true;
      window.mdlhCartOpen = wrappedOpen;
    }
    var origRender = window.mdlhCartRender;
    if (typeof origRender === 'function' && !origRender.__mdlWrapped) {
      var wrappedRender = function () {
        try { origRender(); } catch (err) {}
        setTimeout(refresh, 350);
      };
      wrappedRender.__mdlWrapped = true;
      window.mdlhCartRender = wrappedRender;
    }
  }

  /* September 28, 2026: when the bag has its one scroll (#mdlhCdExtras), the code, shipping and tax
     rows live there, under the bottles and samples, and only the subtotal and Checkout stay fixed. */
  function relocate() {
    var host = $('mdlcsHost');
    var suite = $('mdlcs');
    var extras = $('mdlhCdExtras');
    var foot = document.querySelector('.mdlh__cd-foot');
    if (!suite || (!foot && !extras)) return false;
    if (suite.closest('.mdlh__cd-foot') || suite.closest('#mdlhCdExtras')) return true;
    var trust = document.querySelector('.mdlcs-trust');
    if (extras) {
      extras.appendChild(suite);
      if (trust) extras.appendChild(trust);
    } else {
      var checkout = foot.querySelector('.mdlh__cd-checkout');
      if (checkout) foot.insertBefore(suite, checkout);
      else foot.appendChild(suite);
      if (trust) foot.appendChild(trust);
    }
    if (host) host.hidden = true;
    return true;
  }

  function init() {
    if (!relocate()) return;
    if (!bind()) return;
    wrapDrawerGlobals();
    refresh();
    window.addEventListener('pageshow', refresh);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
